/**
 * Centralized, typed URL builders for every external API the app talks to.
 *
 * Hosts come from the runtime config accessor (`getConfig()`, read at call time) and the path
 * fragments live here — so call sites use named methods (e.g. `materialStorageApi`) instead of
 * repeating hardcoded paths. Each grouped object is typed as its API contract.
 */
import { getConfig } from '@/config/runtimeConfig';
// --- Material storage (material DB) ----------------------------------------------------------
var MATERIAL_DB_RELEASES_PATH = '/materialdb/public/v1/releases';
/** Append the (client-visible) material-DB subscription key as a query param. */
var withSubscriptionKey = function (url) {
    var separator = url.includes('?') ? '&' : '?';
    return "".concat(url).concat(separator, "subscription-key=").concat(getConfig().materialStorageSubscriptionKey);
};
var materialReleasesUrl = function (suffix) {
    return withSubscriptionKey("".concat(getConfig().materialStorageUrl).concat(MATERIAL_DB_RELEASES_PATH).concat(suffix));
};
export var materialStorageApi = {
    latestReleasePackage: function () { return materialReleasesUrl('/latest/CMme'); },
    materialByName: function (releaseId, materialName) {
        return materialReleasesUrl("/".concat(releaseId, "/").concat(materialName));
    },
    materialByArticleNumber: function (releaseId, materialNumber) {
        return materialReleasesUrl("/".concat(releaseId, "/article/").concat(materialNumber));
    },
};
// --- PxC portal (My Solutions + customer accounts + portal links) ----------------------------
var MY_SOLUTIONS_API_PATH = '/configuration/my-solutions/api/v2';
var MARKING_EDITOR_PROJECT_PATH = "".concat(MY_SOLUTIONS_API_PATH, "/solutions/marking-editor-project");
/** Build a full PxC portal URL from a path suffix (everything after the host). */
var portalUrl = function (suffix) {
    return "".concat(getConfig().pxcPortalUrl).concat(suffix);
};
export var pxcPortalApi = {
    customersAccess: function (query) {
        return portalUrl("".concat(MY_SOLUTIONS_API_PATH, "/access?").concat(query));
    },
    customerAccounts: function (query) {
        return portalUrl("/customer/secure/api/v1/account-selection/accounts?".concat(query));
    },
    createSolution: function (query) { return portalUrl("".concat(MARKING_EDITOR_PROJECT_PATH, "?").concat(query)); },
    solutionAttachments: function (solutionId, query) {
        return portalUrl("".concat(MARKING_EDITOR_PROJECT_PATH, "/").concat(solutionId, "/attachments?").concat(query));
    },
    solutionProjectData: function (solutionId, query) {
        return portalUrl("".concat(MARKING_EDITOR_PROJECT_PATH, "/").concat(solutionId, "/project-data?").concat(query));
    },
    submitSolution: function (solutionId, query) {
        return portalUrl("".concat(MARKING_EDITOR_PROJECT_PATH, "/").concat(solutionId, "/submit?").concat(query));
    },
    solutionPreviewImage: function (solutionId, position, query) {
        return portalUrl("".concat(MARKING_EDITOR_PROJECT_PATH, "/").concat(solutionId, "/images/").concat(position, "?").concat(query));
    },
    mySolutionsPage: function (query) { return portalUrl("/configuration/my-solutions?".concat(query)); },
    portalHome: function () { return portalUrl('/de-de/'); },
};
// --- User auth ------------------------------------------------------------------------------
var MARKING_EDITOR_CONFIGURATOR_PATH = '/configuration/marking-editor-configurator';
export var userAuthApi = {
    signinRedirect: function (query) {
        return "".concat(getConfig().userAuthUrl, "/signin?").concat(query, "&redir=").concat(MARKING_EDITOR_CONFIGURATOR_PATH, "?").concat(query);
    },
};
